import React, { useEffect, useRef, useState } from "react";
import "./styles.css";
import "../../components/fontStyling.css";
import "./layout.css";

import { useTranslation } from "react-i18next";
import ShopperLogin from "../../components/shopperLogin/ShopperLogin";
import { Divider, Typography } from "antd";
import { useDispatch, useSelector } from "react-redux";
import {
  removeUpdatedShopperDetails,
  selectExpiryTimeStamp,
  selectIsAdditionalInfoPending,
  setIsSessionExpired,
  setIsSessionInvalid,
  updatePaymentMethodDictionary,
  updateShopperDetails,
  updateUniqueReference,
} from "../../../slices/PaymentSessionDetailsSlice";
import OrderSummary from "../../components/orderSummary/OrderSummary";
import PaymentSummary from "../../components/paymentSummary/PaymentSummary";

import Loading from "../../components/loadingScreen/Loading";
import BottomFooter from "../../components/checkoutFooter/BottomFooter";
import PaymentOptions from "../../components/paymentOptions/PaymentOptions";
import {
  checkTheShopperRefIsCorrect,
  deleteCookie,
  generateDynamicLogo,
  generateDynamicStyling,
  getStorage,
} from "../../../Utils/utils";
import DeliveryAddress from "../../components/address/deliveryAddress";
import AdditionalInformation from "../../components/additionalInformation/AdditionalInformation";
import {
  resetShopperInfo,
  selectGuestCheckout,
  selectShowLogout,
  selectIsGuestLoggedIn,
  selectShowLogin,
  selectMobileNumber,
} from "../../../slices/ShopperInfoSlice";
import ShopperLoginWebConatiner from "../../components/shopperLogin/ShopperLoginWebConatiner";
import CardContainer from "../../resuableComponents/cardContainer/CardContainer";
import {
  getSavedIntsruments,
  selectSavedInstruments,
  setSavedInstruments,
  updateSelectedInstruments,
} from "../../../slices/SavedInstrumentSlice";
import { selectActivePaymentMethod } from "../../../slices/PaymentButtonSlice";
import { changeUpiVpa } from "../../../slices/UpiSlice";
import ErrorPage from "../../components/errorPages/errorPage";
import { selectUnauthorised, resetUnauthorised } from "../../../slices/ApiErrorSlice";
import ErrorModal from "../../components/modals/errorModal/ErrorModal";
import { selectSavedAddresses } from "../../../slices/SavedAddressSlice";
import { CloseCircleOutlined, InfoCircleOutlined } from "@ant-design/icons";
import ExpiryTimer from "../../resuableComponents/ExpiryTimer.jsx";
import {
  checkoutLoadedAnalytics,
  logoutModalOpenedEvent,
  logoutModalClosedEvent,
  logoutCompleteEvent,
  showLoginPageEvent,
} from "../../../Utils/uiAnalytics";
import PaymentSuccess from "../../components/paymentSuccess/PaymentSuccess";
import TranslateText from "../../resuableComponents/TranslateText.jsx";
import { isEmpty } from "lodash";
import OnDemand from "../../components/OnDemand/OnDemand.jsx";
import Offers from "../../components/Offers/Offers.jsx";
import { openAddressComponent } from "../../../slices/PaymentSessionDetailsSlice";
import timer_worker_script from "../../../web-workers/timerWorker.js";

export default function Layouts() {
  const { t } = useTranslation();
  const sessionDetails = useSelector((state) => state.paymentSessionDetails.sessionDetails);
  const tokenType = useSelector((state) => state.paymentSessionDetails.tokenType);
  const unauthorised = useSelector((state) => selectUnauthorised(state));
  const isLoggedIn = useSelector((state) => state.shopperInfo.isLoggedIn);
  const guestCheckout = useSelector((state) => selectGuestCheckout(state));
  const showLogout = useSelector(selectShowLogout);
  const addressCollapse = useSelector((state) => state.paymentSessionDetails.addressCollapse);
  const isAdditionalInfoPending = useSelector(selectIsAdditionalInfoPending);
  const hasEnabledCustomFields = useSelector((state) => (state.additionalComponents.customFields || []).some((f) => f?.enabled === true));
  const activePaymentMethod = useSelector((state) => selectActivePaymentMethod(state));
  const isShippingAddressDisplay = useSelector((state) => state.paymentSessionDetails.isShippingAddressDisplay);
  const { showEmailAddress, showFullName, showContactNumber } = useSelector((state) => state.additionalComponents);
  const expiryTimeStamp = useSelector((state) => selectExpiryTimeStamp(state));
  const [loading, setLoading] = useState(true);
  const [duration, setDuration] = useState(null);
  const [showContent, setShowContent] = useState(false);
  const isSessionExpired = useSelector((state) => state.paymentSessionDetails.isSessionExpired);
  const callerType = useSelector((state) => state.paymentSessionDetails.callerType);
  const isSessionInvalid = useSelector((state) => state.paymentSessionDetails.isSessionInvalid);
  const isSessionPaid = useSelector((state) => state.paymentSessionDetails.isSessionPaid);
  const technicalError = useSelector((state) => state.paymentSessionDetails.technicalError);
  const sessionErrorReasonCode = useSelector((state) => state.paymentSessionDetails.sessionErrorReasonCode);
  const errorMessage = useSelector((state) => state.paymentSessionDetails.errorMessage);
  const updatedShopperDetails = useSelector((state) => state.paymentSessionDetails.updatedShopperDetails);
  const isShowTimerExpiry = useSelector((state) => state.additionalComponents.isShowTimerExpiry);
  const showLogin = useSelector(selectShowLogin);
  const isGuestLoggedIn = useSelector(selectIsGuestLoggedIn);
  const sessionDetailsLoaded = useSelector((state) => state.paymentSessionDetails.sessionDetailsLoaded);
  const onDemandLoaded = useSelector((state) => state.commonPersisted.onDemandLoaded);
  const [openLogoutModal, setOpenLogoutModal] = useState(false);
  const showTotalPaymentSummaryField = useSelector((state) => state.additionalComponents.showTotalPaymentSummaryField);
  const savedInstruments = useSelector((state) => selectSavedInstruments(state));
  const latestSavedAddress = useSelector((state) => state.paymentSessionDetails.latestSavedAddress);
  const workerRef = useRef(null);
  const searchParams = new URLSearchParams(document.location.search);
  const checkoutTokenParams = searchParams.get("token")
  const shopperRef = useSelector((state) => selectMobileNumber(state));
  const handleContinuePayment = () => {
    window.open(window.location.href, "_blank", "noopener,noreferrer");
  };

  useEffect(() => {
    if (expiryTimeStamp) {
      const newDate = new Date();
      const expTime = new Date(expiryTimeStamp);
      const timeDiff = expTime - newDate;
      const diffInSeconds = Math.floor(timeDiff / 1000);
      setDuration(diffInSeconds);
    }
  }, [expiryTimeStamp]);

  const dispatch = useDispatch();
  useEffect(() => {
    const searchParams = new URLSearchParams(document.location.search);
    const token = searchParams.get("token");
    if (
      token !== sessionDetails?.token ||
      !sessionDetailsLoaded ||
      !sessionDetails?.token ||
      !shopperRef ||
      !checkTheShopperRefIsCorrect(
        shopperRef,
        sessionDetails?.paymentDetails?.shopper?.uniqueReference
      )
    ) return;
    if (sessionDetails) {
      generateDynamicStyling(sessionDetails);
    }
    let checkoutToken = checkoutTokenParams || sessionDetails?.token
    if (isLoggedIn && !guestCheckout && checkoutToken && !isEmpty(sessionDetails)) {
      dispatch(
        getSavedIntsruments({ checkoutToken: checkoutToken, shopperRef })
      );
    }

  }, [sessionDetails, isLoggedIn, guestCheckout, shopperRef, sessionDetailsLoaded]);

  useEffect(() => {
    if (savedInstruments?.length >= 0) {
      dispatch(
        updatePaymentMethodDictionary({
          Recommended: savedInstruments,
        })
      );
    }
  }, [savedInstruments]);

  useEffect(() => {
    if (Object.keys(sessionDetails)?.length) {
      const delay = setTimeout(() => {
        setLoading(false);
        setShowContent(true);
      }, 400);

      return () => clearTimeout(delay);
    } else if (sessionDetails?.length === 0) {
      setLoading(false);
    }
  }, [sessionDetails]);

  useEffect(() => {
    if (activePaymentMethod != "UpiSaved") {
      dispatch(updateSelectedInstruments(null));
    }
    dispatch(changeUpiVpa(null));
  }, [activePaymentMethod]);

  useEffect(() => {
    if (sessionDetails) {
      const isCheckoutDomain = window.location.hostname.includes(
        "checkout.boxpay.tech"
      );
      const isNewCheckoutDomain = window.location.hostname.includes(
        "checkout-v2.boxpay.tech"
      );
      const isPaymentLinkDomain =
        window.location.hostname.includes("pl.boxpay.tech");
      if (
        (callerType === "PAYMENT_LINK" &&
          (isCheckoutDomain || isNewCheckoutDomain)) ||
        (callerType === "CHECKOUT" && isPaymentLinkDomain)
      ) {
        dispatch(setIsSessionInvalid(true));
      }
    }
  }, [sessionDetails, callerType]);

  useEffect(() => {
    if (unauthorised) {
      dispatch(resetShopperInfo());
      dispatch(setSavedInstruments([]));
      dispatch(resetUnauthorised());
    }
  }, [unauthorised]);

  const handleLogout = () => {
    logoutCompleteEvent();

    dispatch(resetShopperInfo());
    dispatch(openAddressComponent());
    dispatch(removeUpdatedShopperDetails());
    setOpenLogoutModal(false);
    sessionStorage.removeItem("latestSaved");
    dispatch(setSavedInstruments([]));

    // shopper token
    localStorage.removeItem("sessionToken");
    sessionStorage.removeItem("s_d");
    sessionStorage.removeItem("addressCollapse");
    localStorage.removeItem("isUserLoggedIn");
    deleteCookie("shopper_token")

  };

  const handleTimerExpire = () => {
    dispatch(setIsSessionExpired(true));
  };

  // const shopperRef = localStorage.getItem("shopperRef");
  useEffect(() => {
    if (shopperRef) {
      dispatch(updateUniqueReference(shopperRef));
    } else if (latestSavedAddress) {
      const selectedCardData = latestSavedAddress;
      const currentPhoneNumber = selectedCardData?.phoneNumber;
      const currentEmail = selectedCardData?.email;
      if (sessionDetails?.paymentDetails?.shopper?.phoneNumber !== currentPhoneNumber) {
        dispatch(updateUniqueReference(currentPhoneNumber));
      }
      if (sessionDetails?.paymentDetails?.shopper?.email !== currentEmail) {
        dispatch(updateUniqueReference(currentEmail));
      }
      if (sessionDetails?.paymentDetails?.shopper?.phoneNumber === currentPhoneNumber &&
        sessionDetails?.paymentDetails?.shopper?.email === currentEmail) {
        dispatch(
          updateUniqueReference(
            sessionDetails?.paymentDetails?.shopper?.phoneNumber ||
            sessionDetails?.paymentDetails?.shopper?.uniqueReference
          )
        );
      }
      dispatch(updateShopperDetails({ selectedCardData }));
    }
  }, [sessionDetails, latestSavedAddress, shopperRef]);

  // useEffect(() => {
  //   if (duration) {
  //     const timerWorker = new Worker(timer_worker_script);
  //     timerWorker.postMessage({ duration: duration });
  //     timerWorker.onmessage = ({ data }) => {
  //       if (data === "done") {
  //         clearInterval(timerWorker);
  //         handleTimerExpire();
  //         timerWorker.terminate();
  //       }
  //     };
  //   }
  // }, [duration, isShowTimerExpiry]);
  useEffect(() => {
    if (duration > 0) {
      // If any old worker exists → kill it
      if (workerRef.current) {
        workerRef.current.terminate();
      }

      // Create a new worker
      const timerWorker = new Worker(timer_worker_script);
      workerRef.current = timerWorker;

      // Start countdown
      timerWorker.postMessage({ action: "start", duration });

      timerWorker.onmessage = ({ data }) => {
        if (data === "done") {
          handleTimerExpire();
          timerWorker.terminate();
          workerRef.current = null;
        }
      };

      // Cleanup if component unmounts
      return () => {
        timerWorker.terminate();
        workerRef.current = null;
      };
    }

    // If duration <= 0
    if (duration === 0) {
      handleTimerExpire();
    }
  }, [duration]);

  return (
    <>
      <ErrorModal
        icon={
          <CloseCircleOutlined style={{ color: "#FAAD14", fontSize: "22px" }} />
        }
        title={`${t("LOGOUT_CONFIRMATION")}?`}
        desc={`${t("SESSION_END_WARNING")}.`}
        showModal={openLogoutModal}
        primaryOnClick={() => handleLogout()}
        secondaryOnClick={() => {
          logoutModalClosedEvent();
          setOpenLogoutModal(false);
        }}
        primaryBtnText={t("YES_LOGOUT")}
        secondaryBtnText={t("NO")}
        showSecondaryButton={true}
      />

      {loading ? (
        <Loading
          text={`${t("TAKING_BACK_TO_CHECKOUT")}`}
          subText={t("NOTE_AVOID_BACK_BUTTON")}
        />
      ) : (
        <>
          {isSessionPaid ? (
            <PaymentSuccess />
          ) : isSessionExpired ? (
            <ErrorPage
              imgUrl="/assets/errorImage/sessionExpired.svg"
              heading={
                callerType === "PAYMENT_LINK"
                  ? t("EXPIRED_PAYMENT_LINK")
                  : t("EXPIRED_SESSION")
              }
              subHeading={
                callerType === "PAYMENT_LINK"
                  ? t("MAY_CLOSE_WINDOW")
                  : t("GO_BACK_TRY_AGAIN")
              }
            />
          ) : isSessionInvalid ? (
            <ErrorPage
              imgUrl="/assets/errorImage/invalidSession.svg"
              heading={
                callerType === "PAYMENT_LINK"
                  ? t("INVALID_PAYMENT_LINK")
                  : t("INVALID_SESSION")
              }
              subHeading={
                callerType === "PAYMENT_LINK"
                  ? t("CHANGE_URL_CHECK_AGAIN")
                  : t("CONTACT_SUPPORT")
              }
            />
          ) : technicalError ? (
            <ErrorPage
              imgUrl="/assets/errorImage/technical.svg"
              heading={sessionErrorReasonCode === "BE_1607" ? (tokenType === "checkout-token" ? t("INVALID_CHECKOUT_TOKEN") : t("INVALID_PAYMENT_LINK")) : t("TECHNICAL_ERROR")}
              subHeading={sessionErrorReasonCode === "BE_1607" ? (tokenType === "checkout-token" ? t("CONTACT_MERCHANT") : t("CONTACT_PAYMENT_LINK_PROVIDER")) : <> <Typography>
                <TranslateText label={"TEMPORARY_ISSUE_MESSAGE"}>We ran into a temporary issue. Please</TranslateText>{" "}
                <span className="errorRetryLink" onClick={handleContinuePayment}>
                  <TranslateText label={"CLICK_HERE"}>click here</TranslateText>
                </span>{" "}
                <TranslateText label={"RELOAD_AND_CONTINUE_PAYMENT"}>to reload the page and continue your Payment.</TranslateText>
              </Typography></>}
              errorDetails={errorMessage}
              showContactSupport={true}
            />
          ) : showTotalPaymentSummaryField && !onDemandLoaded ? (
            <OnDemand />
          ) : (
            <div className="domestic-layout-root">
              {showContent && (
                <>
                  <div className="review-layout-content">
                    <div className="review-pay-container">
                      {(showEmailAddress ||
                        showFullName ||
                        showContactNumber ||
                        isShippingAddressDisplay ||
                        (isShowTimerExpiry && duration)) && (
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                            }}
                          >
                            <Typography className="review-pay">
                              <TranslateText label={"REVIEW_AND_PAY"}>
                                Review & Pay
                              </TranslateText>
                            </Typography>
                            {isShowTimerExpiry && duration && (
                              <>
                                <Typography
                                  className="regular16Heading"
                                  style={{ color: "var(--Neutral-Grey-1000)" }}
                                >
                                  <TranslateText label={"WITHIN"}>
                                    within
                                  </TranslateText>
                                  <span
                                    className="regular16Heading"
                                    style={{
                                      color: "var(--Red-900)",
                                      fontWeight: 600,
                                      paddingLeft: "0.5rem",
                                    }}
                                  >
                                    <ExpiryTimer
                                      duration={duration}
                                      callback={handleTimerExpire}
                                    />
                                  </span>
                                </Typography>
                              </>
                            )}
                          </div>
                        )}

                      <div className="domestic-layout-left-side-header">
                        {showLogout && (
                          <div
                            className="domestic-layout-left-side-header-logout"
                            onClick={() => {
                              logoutModalOpenedEvent();
                              setOpenLogoutModal(true);
                            }}
                          >
                            {generateDynamicLogo(
                              "logout",
                              "16px",
                              "16px",
                              sessionDetails?.merchantDetails?.checkoutTheme
                                ?.headerColor
                            )}
                            <Typography className="dynamic-title logout-font">
                              <TranslateText label={"LOGOUT"}>
                                Logout
                              </TranslateText>
                            </Typography>
                          </div>
                        )}
                        {isGuestLoggedIn && (
                          <div
                            className="domestic-layout-left-side-header-logout"
                            onClick={() => {
                              showLoginPageEvent();
                              dispatch(resetShopperInfo());
                            }}
                          >
                            {generateDynamicLogo(
                              "login",
                              "16px",
                              "16px",
                              sessionDetails?.merchantDetails?.checkoutTheme
                                ?.headerColor
                            )}
                            <Typography className="dynamic-title logout-font">
                              <TranslateText label={"LOGIN"}>
                                Login
                              </TranslateText>
                            </Typography>
                          </div>
                        )}
                      </div>
                    </div>

                    <div style={{ display: "none" }}></div>
                  </div>
                  <div className="domestic-layout-content">
                    <div className="domestic-layout-left-side">
                      {showLogin && (
                        <div style={{ marginBottom: "24px" }}>
                          <ShopperLoginWebConatiner
                            children={<ShopperLogin />}
                          />
                        </div>
                      )
                      }
                      {!showLogin ? (
                        <div
                          style={{
                            marginBottom:
                              (showEmailAddress ||
                                showFullName ||
                                showContactNumber ||
                                isShippingAddressDisplay) &&
                              "24px",
                          }}
                        >
                          <DeliveryAddress />
                        </div>
                      ) : (
                        isShippingAddressDisplay && (
                          <div
                            className="emptyCard"
                            style={{ marginBottom: "24px" }}
                          >
                            <CardContainer
                              content={
                                <div className="emptyCardHeading">
                                  <img
                                    src="/assets/address/truck.svg"
                                    alt="delivery"
                                    className="emptyCardIcon"
                                  />
                                  <Typography className="emptyCardHeading dynamic-font-family">
                                    <TranslateText label={"DELIVERY_ADDRESS"}>
                                      Delivery Address
                                    </TranslateText>
                                  </Typography>
                                </div>
                              }
                            />
                          </div>
                        )
                      )}
                      {hasEnabledCustomFields && (
                        !showLogin &&
                          addressCollapse ? (
                          <AdditionalInformation />
                        ) : (
                          <div
                            className="emptyCard"
                            style={{ marginBottom: "24px" }}
                          >
                            <CardContainer
                              content={
                                <div className="emptyCardHeading">
                                  <InfoCircleOutlined className="emptyCardIcon" />
                                  <Typography className="emptyCardHeading dynamic-font-family">
                                    <TranslateText label={"ADDITIONAL_INFORMATION"}>
                                      Additional Information
                                    </TranslateText>
                                  </Typography>
                                </div>
                              }
                            />
                          </div>
                        )
                      )}
                      {!showLogin &&
                        addressCollapse &&
                        !isAdditionalInfoPending &&
                        Object.keys(updatedShopperDetails)?.length ? (
                        <div>
                          <PaymentOptions />
                        </div>
                      ) : (
                        <div className="emptyCard">
                          <CardContainer
                            content={
                              <div className="emptyCardHeading">
                                <img
                                  src="/assets/cardHeader/card.svg"
                                  alt="card"
                                  className="emptyCardIcon"
                                />
                                <Typography className="emptyCardHeading dynamic-font-family">
                                  <TranslateText label={"PAYMENT_OPTIONS"}>
                                    Payment Options
                                  </TranslateText>
                                </Typography>
                              </div>
                            }
                          />
                        </div>
                      )}
                    </div>
                    <div className="domestic-layout-right-side">
                      <OrderSummary />
                      {sessionDetails?.anyOfferAvailable && <Offers />}
                      <PaymentSummary />
                    </div>
                  </div>
                  <Divider className="domestic-layout-content-footer-divider" />
                  <div className="domestic-layout-footer">
                    <BottomFooter />
                  </div>
                </>
              )}
            </div>
          )}
        </>
      )}
    </>
  );
}
